import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { MenuQuantityItemEnum } from "../../../models/menu";
import { SchedulingArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";

export function entityKeyResolver<T extends SchedulingArea>(name: Extract<keyof T, string>): string { return name; };

export const schedulingMenu: MenuMainNode = {
    icon: 'schedulingIconTemplate',
    title: 'Menu.Scheduling.Name',    
    rootPath: '/scheduling',
    areaPermissionKey: permissionAreaKeyNameOf('scheduling'),
    children: [
        {
            title: 'Menu.Scheduling.Scheduler.Name',
            abbreviation: 'Menu.Scheduling.Scheduler.Abbreviation',
            link: '/scheduling/scheduler',
            entityPermissionKey: entityKeyResolver("scheduler")
        },
        {
            title: 'Menu.Scheduling.Confirmation.Name',
            abbreviation: 'Menu.Scheduling.Confirmation.Abbreviation',
            link: '/scheduling/confirmations',
            entityPermissionKey: entityKeyResolver("confirmation")
        },
        {
            title: 'Menu.Scheduling.Reschedule.Name',
            abbreviation: 'Menu.Scheduling.Reschedule.Abbreviation',
            link: '/scheduling/reschedules',
            entityPermissionKey: entityKeyResolver("reschedule")
        },
        {
            title: 'Menu.Scheduling.WaitList.Name',
            abbreviation: 'Menu.Scheduling.WaitList.Abbreviation',
            link: '/scheduling/wait-list-items',
            quantityType: MenuQuantityItemEnum.WaitList,
            entityPermissionKey: entityKeyResolver("waitList")
        },
        //{
        //    title: 'Menu.Scheduling.AppointmentRequests.Name',
        //    abbreviation: 'Menu.Scheduling.AppointmentRequests.Abbreviation',
        //    link: '/scheduling/appointment-requests',
        //    quantityType: MenuQuantityItemEnum.AppointmentRequests,
        //    entityPermissionKey: entityKeyResolver("appointmentRequests")
        //},
        {
            title: 'Menu.Scheduling.Recalls.Name',
            abbreviation: 'Menu.Scheduling.Recalls.Abbreviation',
            link: '/scheduling/recalls',
            quantityType: MenuQuantityItemEnum.Recalls,
            entityPermissionKey: entityKeyResolver("recalls")
        },
        {
            title: 'Menu.Scheduling.Appointments.Name',
            abbreviation: 'Menu.Scheduling.Appointments.Abbreviation',
          link: '/scheduling/appointments',
          quantityType: MenuQuantityItemEnum.Appointments,
            entityPermissionKey: entityKeyResolver("appointments")
        },
        {
            title: 'Menu.Scheduling.CalendarReport.Name',
            abbreviation: 'Menu.Scheduling.CalendarReport.Abbreviation',
            link: '/scheduling/calendar-report',
            entityPermissionKey: entityKeyResolver("calendarReport")
        },
        {
            title: 'Menu.Scheduling.ReferringPhysicianLetters.Name',
            abbreviation: 'Menu.Scheduling.ReferringPhysicianLetters.Abbreviation',
            link: '/scheduling/ref-phys-letters',
            entityPermissionKey: entityKeyResolver("referringPhysicianLetters")
        }
    ]
};
